import React, { useState, useEffect } from "react";
import CustomHeading from "../../components/common/CustomHeading";
import CustomSearch from "../../components/common/CustomSearch";
import CustomButton from "../../components/common/CustomButton";
import CustomTable from "../../components/common/CustomTable";
import { BiEdit } from "react-icons/bi";
import CustomSidebar from "../../components/common/CustomSidebar";
import { ToastContainer } from "react-toastify";
import { validateInput } from "../../utils/regexValidators";
import { useNavigate } from "react-router-dom";
import {
  showErrorToast,
  showSuccessToast,
} from "../../components/Constant/Notification";
import { getBasePathByUserRole } from "../../utils/roleRoutes";
import UserService from "../Services/UserService";
import TeamService from "../Services/TeamService";
import AdminAppBar from "../../components/adminComponents/AdminAppBar";
import InfoModel from "../../components/shareableContainer/InfoModel";
import UserFilter from "./UserFilter";
import CustomChip from "../../components/common/CustomChip";
import { MdFilterListAlt } from "react-icons/md";

const UserList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [visibleForm, setVisibleForm] = useState(false);
  const [userList, setUserList] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageToken, setPageToken] = useState(null);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageTokens, setPageTokens] = useState([null]);
  const [cache] = useState(() => new Map());
  const [roleCount, setRoleCount] = useState({});
  const [dealCount, setDealCount] = useState(0);
  const [leadCount, setLeadCount] = useState(0);
  const [status, setStatus] = useState(true);
  const [infoShow, setInfoShow] = useState(false);
  const [users, setUsers] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    department: null,
    team: null,
  });
  const [userForm, setUserForm] = useState({
    userId: "",
    name: "",
    email: "",
    empId: "",
    phone: "",
    role: "",
    team: "",
    status: true,
    isIvr: false,
  });

  const navigate = useNavigate();

  const getCacheKey = (page, search, role, department, team) =>
    `${page}_${search}_${role || "ALL"}_${department || "ALL"}_${
      team || "ALL"
    }`;

  const getUserList = async ({
    search = "",
    page = 1,
    direction = "",
    pageToken: customToken = null,
    role = null,
    department = null,
    team = null,
  } = {}) => {
    const cacheKey = getCacheKey(page, search, role, department, team);
    const tokenForPage = customToken ?? pageTokens[page - 1] ?? null;

    console.log("Department and Team in getUserList:", { department, team });

    if (cache.has(cacheKey)) {
      const cachedData = cache.get(cacheKey);
      setUserList(cachedData.users);
      setUserCount(cachedData.maxCount);
      setHasMore(cachedData.hasMore);
      setNextPageToken(cachedData.nextPageToken);
      setPrevPageToken(cachedData.prevPageToken);
      setCurrentPage(page);
      setPageToken(tokenForPage);
      console.log(
        "Data loaded from cache for page:",
        page,
        "cacheKey:",
        cacheKey
      );
      return;
    }

    try {
      setLoading(true);

      const body = {
        limit: pageSize,
        searchKey: search.trim() || null,
        role: role ? role : null,
        departments: department ? [department.label] : null,
        teams: team ? [team.value] : null,
        startAfter: direction === "next" ? tokenForPage : null,
        prev: direction === "prev" ? tokenForPage : null,
        direction,
      };

      const response = await UserService.fetchUsers(body);
      const users = response.data.users || [];
      const maxCount = response.data.maxCount || 0;
      const nextToken = response.data?.pagination?.lastDocId || null;
      const prevToken = response.data?.pagination?.firstDocId || null;
      setRoleCount(response.data?.aggregation || {});

      const calculatedHasMore = response.data?.pagination?.hasMore || false;

      const cacheData = {
        users,
        maxCount,
        hasMore: calculatedHasMore,
        nextPageToken: nextToken,
        prevPageToken: prevToken,
      };

      cache.set(cacheKey, cacheData);
      console.log("Data cached for page:", page, "cacheKey:", cacheKey);

      if (direction === "next" && nextToken && calculatedHasMore) {
        setPageTokens((prev) => {
          const newTokens = [...prev];
          if (newTokens.length === page) {
            newTokens.push(nextToken);
          }
          return newTokens;
        });
      } else if (direction === "previous" && prevToken && page > 1) {
        setPageTokens((prev) => {
          const newTokens = [...prev];
          if (newTokens.length >= page && newTokens[page - 1] !== prevToken) {
            newTokens[page - 1] = prevToken;
          }
          return newTokens;
        });
      }

      setUserList(users);
      setUserCount(maxCount);
      setHasMore(calculatedHasMore);
      setNextPageToken(nextToken);
      setPrevPageToken(prevToken);
      setPageToken(direction === "next" ? nextToken : prevToken);
      setCurrentPage(page);
    } catch (error) {
      console.error("Error fetching user list:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    cache.clear();
    setCurrentPage(1);
    setPageToken(null);
    setPageTokens([null]);
    getUserList({
      search: searchTerm,
      page: 1,
      role: selectedRole,
      department: selectedFilters.department,
      team: selectedFilters.team,
    });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handlePageChange = (token, direction) => {
  
    if (direction === "next" && hasMore) {
      const newPage = currentPage + 1;
      console.log(
        "Moving to next page:",
        newPage,
        "with token:",
        nextPageToken
      );
      getUserList({
        search: searchTerm,
        pageToken: nextPageToken,
        page: newPage,
        direction: "next",
        role: selectedRole,
        department: selectedFilters.department,
        team: selectedFilters.team,
      });
    } else if (direction === "previous" && currentPage > 1) {
      const newPage = currentPage - 1;
      const prevToken = pageTokens[newPage - 1] || prevPageToken;
      console.log(
        "Moving to previous page:",
        newPage,
        "with token:",
        prevToken
      );
      getUserList({
        search: searchTerm,
        pageToken: prevToken,
        page: newPage,
        direction: "prev",
        role: selectedRole,
        department: selectedFilters.department,
        team: selectedFilters.team,
      });
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  const handleRoleChange = (role) => {
    setSelectedRole(role);
  };

  const handleFilterChange = (filters) => {
    setSelectedFilters({
      department: filters.department,
      team: filters.team,
    });
    cache.clear();
    setCurrentPage(1);
    setPageToken(null);
    setPageTokens([null]);
    getUserList({
      search: searchTerm,
      page: 1,
      role: selectedRole,
      department: filters.department,
      team: filters.team,
    });
    setIsFilterOpen(false);
  };

  const handleRemove = (filterType) => {
    setSelectedFilters({ department: null, team: null });
    cache.clear();
    setCurrentPage(1);
    setPageToken(null);
    setPageTokens([null]);
    getUserList({
      search: searchTerm,
      page: 1,
      role: selectedRole,
      department: null,
      team: null,
    });
  };

  const handleClearFilters = () => {
    setSelectedFilters({ department: null, team: null });
    cache.clear();
    setCurrentPage(1);
    setPageToken(null);
    setPageTokens([null]);
    getUserList({ search: searchTerm, page: 1, role: selectedRole });
  };

  const handleUserDetails = (userData) => {
    if (userData) {
      console.log("Handling user details for:", userData);
    }
    setUserForm({
      userId: userData.uid || "",
      name: userData.name || "",
      email: userData.emailId || "",
      empId: userData.employeeId || "",
      phone: userData.phoneNumber || "",
      role: userData.role || "",
      team: userData.teamName || [],
      status: userData.status !== undefined ? userData.status : true,
      isIvr: userData.isIvr || false,
    });
  };

  const fetchUserCount = async () => {
    try {
      const response = await UserService.getUserCount();
      console.log("User count response:", response);
      if (response.status === 200) {
        setRoleCount(response.data || {});
      } else {
        console.error("Failed to fetch user count:", response.data);
      }
    } catch (error) {
      console.error("Error fetching user count:", error);
    }
  };

  const handleUserCreate = async (userData) => {
    console.log("Creating user with data:", userData);
    if (!userData.name || userData.name.trim() === "") {
      showErrorToast("Please enter a valid name.");
      return;
    }
    if (!userData.employeeId || userData.employeeId?.trim() === "") {
      showErrorToast("Please enter a valid employee ID.");
      return;
    }
    if (
      !userData.phoneNumber ||
      !validateInput("phone", userData.phoneNumber)
    ) {
      showErrorToast("Please enter a valid phone number.");
      return;
    }
    if (!userData.role || userData.role.trim() === "") {
      showErrorToast("Please select a valid role.");
      return;
    }
    const showTeamSelect = ["ADMIN", "CMO", "LEAD_UPLOADER"].includes(
      userData.role.toUpperCase()
    );
    if (!showTeamSelect) {
      if (!userData.team || userData.team.length === 0) {
        showErrorToast("Please select a valid team.");
        return;
      }
    }
    if (!validateInput("email", userData.emailId)) {
      showErrorToast("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const response = await UserService.createUser(userData);
      if (response.status === 200) {
        showSuccessToast(response.data.message || "User created successfully");
        setVisibleForm(false);
        setUserForm({
          name: "",
          email: "",
          empId: "",
          phone: "",
          role: "",
          team: "",
          status: true,
          isIvr: false,
        });
        cache.clear();
        setCurrentPage(1);
        setPageToken(null);
        setPageTokens([null]);
        fetchUserCount();
        getUserList({
          search: searchTerm,
          page: 1,
          role: selectedRole,
          department: selectedFilters.department,
          team: selectedFilters.team,
        });
      } else {
        console.error("Failed to create user:", response.data);
      }
    } catch (error) {
      console.error("Error creating user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserUpdate = async (userId, userData) => {
    console.log("Updating user with ID:", userId, "and data:", userData);
    if (!userId || !userData) {
      showErrorToast("Invalid user ID or data.");
      return;
    }
    if (!userData.name || userData.name.trim() === "") {
      showErrorToast("Please enter a valid name.");
      return;
    }
    if (!userData.employeeId || userData.employeeId?.trim() === "") {
      showErrorToast("Please enter a valid employee ID.");
      return;
    }
    if (
      !userData.phoneNumber ||
      !validateInput("phone", userData.phoneNumber)
    ) {
      showErrorToast("Please enter a valid phone number.");
      return;
    }

    try {
      const response = await UserService.updateUser(userId, userData);
      console.log("User update response:", response);

      if (response.status === 200) {
        showSuccessToast(response.data.message || "User updated successfully");
        setVisibleForm(false);
        setUserForm({
          name: "",
          email: "",
          empId: "",
          phone: "",
          role: "",
          team: "",
          status: true,
        });
        cache.clear();
        setCurrentPage(1);
        setPageToken(null);
        setPageTokens([null]);
        getUserList({
          search: searchTerm,
          page: 1,
          role: selectedRole,
          department: selectedFilters.department,
          team: selectedFilters.team,
        });
      } else {
        console.error("Failed to update user:", response.data);
      }
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const userData = async () => {
    try {
      const userResponse = await TeamService.getUserName();
      setUsers(userResponse.data.users);
      console.log(userResponse);
    } catch (error) {
      console.log("Error");
    }
  };

  useEffect(() => {
    cache.clear();
    setCurrentPage(1);
    setPageToken(null);
    setPageTokens([null]);
    getUserList({
      search: searchTerm,
      page: 1,
      role: selectedRole,
      department: selectedFilters.department,
      team: selectedFilters.team,
    });
  }, [pageSize, selectedRole]);

  useEffect(() => {
    fetchUserCount();
  }, []);

  useEffect(() => {
    if (leadCount || dealCount) {
      userData();
    }
  }, [leadCount, dealCount]);

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (_, record) => (
        <div className="capitalize  truncate w-[200px] line-clamp-2 cursor-pointer text-center">
          <div className="flex text-start flex-col gap-2">
            <div className="capitalize ">{record?.name}</div>
            <div className="text-customGreen">Emp ID: {record?.employeeId}</div>
          </div>
        </div>
      ),
    },
    {
      key: "role",
      title: "Role",
      render: (_, record) => (
        <div className="truncate">{record?.role ?? "N/A"}</div>
      ),
    },
    {
      key: "department",
      title: "Department",
      render: (_, record) => (
        <div className="truncate">{record?.department ?? "N/A"}</div>
      ),
    },
    {
      key: "teamNames",
      title: "Team",
      render: (_, record) => {
        const teamList = record?.teamNames || [];
        const firstTeam = teamList[0];
        const teamCount = teamList.length - 1;
    
        return (
          <div
            className="truncate"
            title={teamList.map((t) => t.name).join(", ")}
          >
            {firstTeam ? (
              <>
                <span>{firstTeam.name}</span>
                {teamCount > 0 && (
                  <span className="text-blue-500"> +{teamCount}</span>
                )}
              </>
            ) : (
              "N/A"
            )}
          </div>
        );
      }
    }
,    
    {
      key: "status",
      title: "Status",
      render: (_, record) =>
        record?.status ? (
          <span className="text-green-500 font-semibold">Active</span>
        ) : (
          <span className="text-red-500 font-semibold">Inactive</span>
        ),
    },
    {
      key: "action",
      title: "Action",
      render: (_, record) => (
        <div
          onClick={() => {
            navigate("/global-setup/user-info", {
              state: { userData: record },
            });
          }}
          className="flex justify-center items-center h-full cursor-pointer"
        >
          <BiEdit className="text-blue-500 text-lg" />
        </div>
      ),
    },
  ];

  const userTab = [
    { lable: "All Users", count: roleCount?.totalUsers || 0 },
    { lable: "BOD", count: roleCount?.roleWiseCount?.BOD || 0 },
    { lable: "Telecaller", count: roleCount?.roleWiseCount?.Telecaller || 0  },
    { lable: "Marketing Executive", count: roleCount?.roleWiseCount?.["Marketing Executive"] || 0 },
    { lable: "Field Worker", count: roleCount?.roleWiseCount?.["Field Worker"] || 0 },
    { lable: "MD", count: roleCount?.roleWiseCount?.MD || 0 },
    { lable: "Admin", count: roleCount?.roleWiseCount?.Admin || 0 },
    { lable: "Lead Uploader", count: roleCount?.roleWiseCount?.["Lead Uploader"] || 0 },
    { lable: "CMO", count: roleCount?.roleWiseCount?.CMO || 0 },
    { lable: "Procurement Head", count: roleCount?.roleWiseCount?.["Procurement Head"] || 0 },
    { lable: "Backend", count: roleCount?.roleWiseCount?.Backend || 0 },
    { lable: "Frontend", count: roleCount?.roleWiseCount?.Frontend || 0 },
    { lable: "Rough Drafter", count: roleCount?.roleWiseCount?.["Rough Drafter"] || 0 },
    { lable: "Procurer", count: roleCount?.roleWiseCount?.Procurer || 0 },
    { lable: "HR", count: roleCount?.roleWiseCount?.HR || 0 }
  ];

  return (
    <div className="bg-appGrayBackground pb-7">
      <AdminAppBar isMenu={false} />
      <ToastContainer />
      <div className="pt-28 px-6">
        <div className="flex items-center justify-between">
          <CustomHeading title={<>Users</>} isIcon={true} />
          <div className="flex items-center gap-4">
            <CustomSearch
              placeholder={"Search User"}
              searchTerm={searchTerm}
              handleSearchSubmit={handleSearchSubmit}
              handleSearchChange={handleSearchChange}
            />
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsFilterOpen(true)}
                className="bg-white justify-between text-base font-medium w-[131px] h-[50px] rounded-[10px] flex items-center gap-3 text-customGreen py-2 px-4 hover:bg-appGreenHover transition duration-300"
              >
                Filters
                <MdFilterListAlt />
              </button>
            </div>
            <CustomButton
              label={"Create User"}
              onClick={() => {
                navigate("/global-setup/user-info");
              }}
            />
          </div>
        </div>

        <div className="flex items-center justify-between mt-8">
          <div className="flex flex-wrap gap-3 py-5 px-1">
            {userTab.map((list, index) => (
              <button
                key={index}
                onClick={() =>
                  handleRoleChange(
                    list.lable === "All Users" ? null : list.lable
                  )
                }
                className={`px-6 h-[50px] rounded-3xl whitespace-nowrap ${
                  selectedRole === list.lable ||
                  (!selectedRole && list.lable === "All Users")
                    ? "bg-white text-customGreen text-base font-semibold shadow"
                    : "bg-white text-gray-700 hover:bg-gray-50"
                }`}
              >
                {list.lable} ({list.count})
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 mt-4">
          {selectedFilters.department && (
            <CustomChip
              label={`Department: ${selectedFilters.department.label}`}
              onRemove={() => handleRemove("department")}
            />
          )}
          {selectedFilters.team && (
            <CustomChip
              label={`Team: ${selectedFilters.team.label}`}
              onRemove={() => handleRemove("team")}
            />
          )}
        </div>

        <div className="w-full mt-[20px]">
          <CustomTable
            columns={columns}
            data={userList}
            isPagination={true}
            pageSize={pageSize}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            currentPage={currentPage}
            nextId={nextPageToken}
            prevId={prevPageToken}
            hasMore={hasMore}
            loading={loading}
          />
        </div>
      </div>
      <CustomSidebar
        visible={isFilterOpen}
        onHide={() => setIsFilterOpen(false)}
        title="Filter Options"
      >
        <UserFilter
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onApplyFilters={handleFilterChange}
          onClearFilters={handleClearFilters}
        />
      </CustomSidebar>
    </div>
  );
};

export default UserList;